import { storeRef } from "@/components/providers/StoreProvider"
import { thunks } from "@/lib/redux/thunks"
import { controllers } from "@/lib/services"
import dayjs from "dayjs"

export const getMinFlights = async (date?: string) => {
  try {

    const flightState = storeRef.current?.getState().flight
    const seletedFlightInput = flightState?.inputFlights[flightState.selectedFligthInputIndex]
    let fromDate = dayjs(seletedFlightInput?.dateFrom)
    let toDate = fromDate.add(14, 'day')

    if (!!date) {
      fromDate = dayjs(date).startOf('month')
      toDate = fromDate.add(1, 'month').endOf('month')

      if (!!flightState?.minFlightsByMonths[`${fromDate.get('month') + 1}`]) {
        if (!!flightState?.minFlightsByMonths[`${toDate.get('month') + 1}`]) {
          return;
        } else {
          fromDate = toDate.startOf('month');
        }
      }

      if (fromDate.valueOf() < dayjs().valueOf()) {
        if (toDate.valueOf() < dayjs().valueOf()) {
          return
        }
        fromDate = dayjs()
      }

      if (fromDate.valueOf() > toDate.valueOf()) {
        return
      }
    }

    const flight = {
      startPoint: seletedFlightInput?.fromAirport?.code,
      endPoint: seletedFlightInput?.toAirport?.code,
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: toDate.format("YYYY-MM-DD"),
      // airline: "ALL"
    }

    const isDomestic = ![
      seletedFlightInput?.fromAirport,
      seletedFlightInput?.toAirport
    ].some(airport => {
      return airport?.isDomestic === '0'
    })

    if (!isDomestic && !!date) {
      return;
    }

    const body = {
      TYPE: 'JSON',
      itinerary: flight,
      currency: "VND",
      language: "VI",
      flightType: isDomestic ? "DOMESTIC" : "INTERNATIONAL",
    }

    if (!date) {
      if (controllers.search_min_flights_v1) {
        controllers.search_min_flights_v1.abort("New request")
        controllers.search_min_flights_v1 = new AbortController()
      }

      await storeRef.current?.dispatch(thunks.search_min_flights_v1({
        body: body
      }) as any).unwrap()

    } else {
      if (controllers.search_min_flights) {
        controllers.search_min_flights.abort("New request")
        controllers.search_min_flights = new AbortController()
      }

      await storeRef.current?.dispatch(thunks.search_min_flights({
        body: body
      }) as any).unwrap()

    }
  } catch (error) {

  }
}